"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _BaseClient2 = _interopRequireDefault(require("./BaseClient"));

var SkuFamilyClient =
/*#__PURE__*/
function (_BaseClient) {
  (0, _inherits2["default"])(SkuFamilyClient, _BaseClient);

  function SkuFamilyClient(getAccessToken) {
    (0, _classCallCheck2["default"])(this, SkuFamilyClient);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SkuFamilyClient).call(this, getAccessToken, 'https://family.products.cimpress.io'));
  }

  (0, _createClass2["default"])(SkuFamilyClient, [{
    key: "getSkusUnderFamily",
    value: function getSkusUnderFamily(skuFamilyId) {
      return this.fetchWithAuth({
        endpointUrl: this.endpointUrl,
        route: "v2/product-family/".concat(skuFamilyId)
      }).then(function (res) {
        return {
          name: (0, _lodash["default"])(res, 'family.name'),
          skus: (0, _lodash["default"])(res, 'family.mcpSkus'),
          fulfillerId: (0, _lodash["default"])(res, 'family.tenant.fulfillerId')
        };
      });
    }
  }]);
  return SkuFamilyClient;
}(_BaseClient2["default"]);

exports["default"] = SkuFamilyClient;